module.exports = __webpack_public_path__ + "img/team-member-05.6cfdf588.jpg";